import Chart, {
    ArgumentAxis,
    CommonSeriesSettings,
    Export,
    Legend,
    LoadingIndicator,
    Point,
    Series,
    Size,
    Strip,
    Title,
    Tooltip,
    ValueAxis
} from 'devextreme-react/chart'
import DateBox from "devextreme-react/date-box"
import {Popup} from "devextreme-react"
import React, {useCallback, useEffect, useState} from 'react'
import {getEnergosferaCounter, getFileEnergosferaCounter} from '../../api/point'
import ScrollView from "devextreme-react/scroll-view";
import { Button } from 'devextreme-react/button';
import {PopupTitleWithIcon} from "../popup-title-with-icon/popup-title-with-icon";
import {faChartBar} from "@fortawesome/free-solid-svg-icons";
import notify from 'devextreme/ui/notify'
import { Buffer } from 'buffer';
import LoadPanel from "devextreme-react/load-panel";
import {SelectBox} from "devextreme-react/select-box";
import ArrayStore from 'devextreme/data/array_store';
import {Template} from "devextreme-react/core/template";
import './energosfera-chart.scss'
import {faChartLine, faChartColumn} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useAuth} from "../../contexts/auth";
import {
    FACT_MARK,
    PLAN_MARK,
    PeakMarksCaption,
    hasPeakMark,
    holidayStrips,
    loadPeakOverlay,
    slotParts,
    withPeakMarks,
} from "../../utils/peak-chart-marks";
const EnergosferaChart = (props) => {

    //const data = props.data new name commit
    const { selectedDog } = useAuth()
    const visible = props.visible
    const point = props.point
    const [data, setData] = useState([])
    const [source, setSource] = useState([])
    const [loading, setLoading] = useState(false)
    const [period1, setPeriod1] = useState(props.period1)
    const [period2, setPeriod2] = useState(props.period2)
    const [title, setTitle] = useState('')
    const [loadingFile, setLoadingFile] = useState(false)
    const [chbBarLine, setChbBarLine] = useState('spline')
    const hour = [{id:0,interval:'half-hour',name:'Получасовые данные'},{id:1,interval:'hour',name:'Почасовые данные'}]
    const dsBarSpline = [{id:0,type:'spline',name:'Линия', IconSrc:faChartLine},{id:1,type:'bar',name:'Столбцы', IconSrc:faChartColumn}]
    const [selectedItem, setSelectedItem] = useState(dsBarSpline[0]);
    const [interval, setInterval] = useState(hour[0].interval);
    const [strips, setStrips] = useState([]);
    //const { selectedDog : {kodDog} } = useAuth()
    const dataSource = new ArrayStore({
        data: hour,
        key: 'interval',
    });

    const onHiddenPopup = () => {
        props.onClosed()
    }

    const calendarOptions = {
        applyValueMode: "useButtons",
        showDropDownButton: true,
    }

    useEffect(() => {
        (async function () {
            await refreshClick()
            //console.log("useEffect");
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible, point])

    function getPointsSource(mas) {
        let res = []
        let item = {}
        for (let i = 0; i < mas.length; i++) {
            item = {
                value: mas[i].name,
                name: mas[i].name
            }
            if (!res.find(el => el.value === mas[i].name)) res.push(item)
        }
        //console.log(res)
        return res
    }

    async function refreshClick(){
        if (visible && point) {
            setLoading(true)
            const overlayPromise = loadPeakOverlay(selectedDog?.kodDog, period1, period2)
            try {
                const res = await getEnergosferaCounter(point, period1, period2, interval)
                if (res.data) {
                    const overlay = await overlayPromise
                    const marked = withPeakMarks(res.data.reads || [], overlay)
                    setSource(getPointsSource(marked))
                    setData(marked)
                    setStrips(holidayStrips(marked, overlay.holidays, 'format_time'))
                    setTitle(res.data.title)
                }
            } catch (e) {
                notify(e.message, 'error', 5000)
            } finally {
                setLoading(false)
            }
        } else {
            setData([])
            setSource([])
            setStrips([])
        }
    }

    async function loadFileEnergosfera() {
        setLoadingFile(true)
        try {
            if (!selectedDog?.kodDog) {
                notify('Не выбран договор', 'error', 5000)
                return
            }
            if (!point) {
                notify('Не выбрана точка учета', 'error', 5000)
                return
            }
            const res = await getFileEnergosferaCounter([point], period1, period2, 'EXCEL', selectedDog.kodDog, interval)
            if (res.isOk) {
                const file = res.data.data
                const filename = res.data.filename
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(file), filename)
            } else {
                notify(res.message, 'error', 5000)
            }
        } catch (e) {
            notify(e.message, 'error', 5000)
        } finally {
            setLoadingFile(false)
        }
    }

    const renderConditionalIcon = useCallback(
        () => <ConditionalIcon value={selectedItem} />,
        [selectedItem],
    );
    const selectionChanged = useCallback((event) => {
        setSelectedItem(event.selectedItem);
        setChbBarLine(event.selectedItem.type)
    }, []);

    return (
        <Popup
            id="popup-energo"
            hideOnOutsideClick={true}
            showCloseButton={true}
            visible={visible}
            height='auto'
            maxHeight={'90%'}
            maxWidth="90%"
            onHiding={onHiddenPopup}
            titleRender={()=>PopupTitleWithIcon(faChartBar, "Текущий профиль потребления по ТУ (online)",onHiddenPopup)}
        >
            <ScrollView width='100%' height='100%'>
                <div>
                    <div className="row mb-4">
                        <div className="col-lg-2 col-md-4 col-sm-4">
                            <DateBox
                                openOnFieldClick={true}
                                calendarOptions={calendarOptions}
                                defaultValue={period1}
                                value={period1}
                                max={period2}
                                displayFormat='dd.MM.yyyy'
                                useMaskBehavior={true}
                                onValueChanged={(e) => setPeriod1(e.value)}
                            />
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-4 mt20xs">
                            <DateBox
                                openOnFieldClick={true}
                            calendarOptions={calendarOptions}
                            defaultValue={period2}
                            value={period2}
                            min={period1}
                            displayFormat='dd.MM.yyyy'
                                useMaskBehavior={true}
                            onValueChanged={(e) => setPeriod2(e.value)}
                        />
                        </div>
                        {process.env.REACT_APP_VISIBLE_SELECT_HALF_HOUR === 'true' &&
                        <div className="col-lg-2 col-md-4 col-sm-4 mt20xs">
                            <SelectBox
                                dataSource={dataSource}
                                displayExpr="name"
                                valueExpr="interval"
                                defaultValue={hour[0].interval}
                                onValueChanged={(e)=> setInterval(e.value)}
                            />
                        </div>
                        }
                        <div className={`col-lg-2 col-md-4 col-sm-4 mt20xs ${process.env.REACT_APP_VISIBLE_SELECT_HALF_HOUR === 'true' ? 'mt20lg' : ''}`}>
                            <SelectBox
                                dataSource={dsBarSpline}
                                defaultValue={dsBarSpline[0].id}
                                selectedItem={selectedItem}
                                displayExpr="name"
                                valueExpr="id"
                                itemRender={Item}
                                dropDownButtonTemplate="conditionalIcon"
                                onSelectionChanged={selectionChanged}
                            >
                                <Template
                                    name="conditionalIcon"
                                    render={renderConditionalIcon}
                                />
                            </SelectBox>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-4 mt20xs mt20md  mt20lg">
                            <Button icon="refresh" text='Обновить' className='w-100' onClick={async(e) => refreshClick()} />
                        </div>
                        <div className={`${process.env.REACT_APP_VISIBLE_SELECT_HALF_HOUR === 'true'?'col-lg-2':'col-lg-4'} col-md-4 col-sm-4 mt20xs mt20md mt20lg text-lg-right w-100`}>
                            <Button icon='xlsfile' className='w-100' text='Выгрузить в Excel' onClick={loadFileEnergosfera} disabled={loadingFile || loading}/>
                            <LoadPanel visible={loadingFile} />
                        </div>
                    </div>
                    <LoadPanel visible={loading} />

                    <div id="chart-demo">
                        <div style={{textAlign: 'center'}}>
                            <span><b>{title}</b></span>
                        </div>
                        <Chart
                            dataSource={data}
                        >
                            <Size height={420}/>
                            <CommonSeriesSettings
                                argumentField="format_time"
                                type={chbBarLine}
                                hoverMode="includePoints"
                            >
                            <Point visible={false} hoverMode="allArgumentPoints" />
                        </CommonSeriesSettings>
                        <ValueAxis position="left">
                            <Title text="КВт/ч" />
                        </ValueAxis>
                        {
                            source.map((item) => {
                                return <Series
                                    key={item.value}
                                    valueField={item.value}
                                    name={item.name}
                                />
                            })
                        }
                        {hasPeakMark(data, PLAN_MARK) && (
                            <Series valueField={PLAN_MARK} name={PLAN_MARK} type="bar" color="#66bb6a" barWidth={2}/>
                        )}
                        {hasPeakMark(data, FACT_MARK) && (
                            <Series valueField={FACT_MARK} name={FACT_MARK} type="bar" color="#fbc02d" barWidth={2}/>
                        )}
                        <ArgumentAxis>
                            {strips.map((band) => (
                                <Strip key={band.day} startValue={band.start} endValue={band.end} color="rgba(255, 192, 203, 0.55)"/>
                            ))}
                        </ArgumentAxis>
                        <Export enabled={true} />
                        <Legend
                            verticalAlignment="bottom"
                            horizontalAlignment="center"
                            hoverMode="excludePoints"
                        />
                        <LoadingIndicator enabled={true} />
                        <Tooltip
                            enabled={true}
                            shared={true}
                            customizeTooltip={customizeTooltip}
                        />
                    </Chart>
                    <span><b>Время московское</b></span>
                    {data.length > 0 && <PeakMarksCaption/>}
                </div>
                    </div>
            </ScrollView>
        </Popup>
    )

    function customizeTooltip(outInfo) {
        const points = outInfo.points || []
        const markNames = new Set([FACT_MARK, PLAN_MARK])
        const values = points.filter((p) => !markNames.has(p.seriesName))
        const valueText = values.length
            ? values.map((p) => `${p.seriesName}: ${p.valueText}`).join('<br/>')
            : `КВт/ч: ${outInfo.originalValue}`
        const marks = []
        const day = slotParts(outInfo.point?.data?.dat_local || outInfo.argument)?.dayKey
        if (day && strips.some((band) => band.day === day)) marks.push('Выходной')
        if (points.some((p) => p.seriesName === PLAN_MARK) || outInfo.point?.data?.[PLAN_MARK] != null) marks.push('Плановый час максимума')
        if (points.some((p) => p.seriesName === FACT_MARK) || outInfo.point?.data?.[FACT_MARK] != null) marks.push('Фактический час максимума')
        return {
            html: `
            <div style="z-index: 10000; position: relative">
                <div class="tooltip-body">
                    <div class="series-name">
                        <span class='top-series-name'>Время: ${outInfo.argumentText}</span>
                    </div>
                    <div class="value-text">
                        <span class='top-series-value'>${valueText}</span>
                    </div>
                    ${marks.length ? `<div>${marks.join(', ')}</div>` : ''}
                </div>
            </div>`,
        };
    }

    function Item({ IconSrc, name }) {
        return (
            <div className="custom-item">
                <FontAwesomeIcon className="icon icon-header-h3 main-color main-color-light" icon={IconSrc} />
                <div className="product-name">{name}</div>
            </div>
        );
    }
    function ConditionalIcon({ value }) {
        if (value) {
            return (
                <FontAwesomeIcon className="main-color main-color-light" icon={value.IconSrc} />
            );
        }
        return <div className="dx-dropdowneditor-icon"></div>;
    }

}

export default EnergosferaChart
